export const buildBillingSettingsPayload = (settings) => {
    const invoiceDueDays = settings.show_due_date
        && settings.invoice_due_days !== null
        && settings.invoice_due_days !== ''
        ? Number(settings.invoice_due_days)
        : null;

    return {
        invoice_issue_mode: settings.invoice_issue_mode,
        invoice_due_mode: settings.invoice_due_mode || 'on_receipt',
        invoice_due_days: invoiceDueDays,
        show_due_date: !!settings.show_due_date,
        allowed_payment_methods: settings.allowed_payment_methods?.length
            ? settings.allowed_payment_methods
            : ['invoice'],
        is_auto_invoice_enabled: !!settings.is_auto_invoice_enabled,
        next_invoice_date: settings.next_invoice_date || null,
    };
};

export const withToggledPaymentMethod = (settings, method) => {
    const current = settings.allowed_payment_methods || [];
    let allowedPaymentMethods = current.includes(method)
        ? current.filter((currentMethod) => currentMethod !== method)
        : [...current, method];

    if (allowedPaymentMethods.length === 0) {
        allowedPaymentMethods = ['invoice'];
    }

    return {
        ...settings,
        allowed_payment_methods: allowedPaymentMethods,
    };
};

const PAYMENT_METHOD_LABELS = {
    invoice: 'Invoice / Terms',
    card: 'Credit Card',
};

export const getAllowedPaymentMethods = (settings) => {
    if (!Array.isArray(settings?.allowed_payment_methods)) return [];

    return settings.allowed_payment_methods.reduce((methods, method) => {
        const normalizedMethod = typeof method === 'string'
            ? method.trim().toLowerCase()
            : '';

        if (
            PAYMENT_METHOD_LABELS[normalizedMethod]
            && !methods.includes(normalizedMethod)
        ) {
            methods.push(normalizedMethod);
        }

        return methods;
    }, []);
};

export const isPaymentMethodAllowed = (settings, method) => (
    getAllowedPaymentMethods(settings).includes(method)
);

export const isPaymentMethodAvailable = (settings, method) => (
    isPaymentMethodAllowed(settings, method)
    && settings?.[`${method}_payment_allowed`] === true
);

export const formatAllowedPaymentMethods = (settings) => {
    const methods = getAllowedPaymentMethods(settings);

    return methods.length > 0
        ? methods.map((method) => PAYMENT_METHOD_LABELS[method]).join(' and ')
        : 'No payment methods enabled';
};
